import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CtAuthenticationService } from '@ctsolution/ct-authentication';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
    constructor(
        private authService: CtAuthenticationService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Verifica se l'utente è autenticato
        if (this.authService.userValue) {
            // Se è loggato, redirige alla dashboard
            return this.router.createUrlTree(['/dashboard']);
        } else {
            // Se non è loggato, redirige al login
            return this.router.createUrlTree(['/auth/login']);
        }
    }
}
